/* The column-mapping step: a list rather than a table, because a column is a name, a few sample
   values and one decision, and a table of those is a list with lines drawn on it. */

/* The step is its own panel now ("2 · Map columns"), so it draws no second box inside it. */
.step {
  margin: 0;
}

.columns {
  list-style: none;
  margin: 10px 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.column {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 14rem);
  gap: 4px 12px;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid var(--line-2);
}

.header {
  font-weight: 600;
  color: var(--ink);
  overflow-wrap: anywhere;
}

.samples {
  grid-column: 1;
  font-size: var(--t-min);
  color: var(--muted);
  overflow-wrap: anywhere;
}

.why {
  grid-column: 1;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.whyCheck {
  color: var(--warn);
}

.choose {
  grid-column: 2;
  grid-row: 1 / span 3;
  min-width: 0;
}

.offer {
  margin: 8px 0;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-left-width: 3px;
  border-radius: 7px;
  background: var(--panel);
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
}

.remember {
  margin: 10px 0 4px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.blocked {
  margin: 8px 0;
  padding: 8px 10px;
  border: 1px solid var(--warn-line);
  border-left-width: 3px;
  border-radius: 7px;
  background: var(--warn-w);
  font-size: var(--t-min);
  line-height: 1.5;
  color: var(--ink-2);
}

.blocked ul {
  margin: 4px 0 0;
  padding-left: 18px;
}

@media (max-width: 40rem) {
  .column {
    grid-template-columns: minmax(0, 1fr);
  }

  .choose {
    grid-column: 1;
    grid-row: auto;
  }
}
